const categoryQueryKeys = {
  all: ['category'] as const,
  lists: () => [...categoryQueryKeys.all, 'list'] as const,
};

export default categoryQueryKeys;
